import React from 'react';
import PropTypes from 'prop-types';

import { Button, ButtonGroup } from 'react-bootstrap';
import { css, StyleSheet } from 'aphrodite';

const ProductFilterMode = Object.freeze({
  ALL: 'all',
  LIVE_DP: 'liveDP',
  LIVE_MFR: 'liveMFR',
  ACTIVE_MFR: 'activeMFR',
  ALL_STATUSES: 'allStatuses',
  DP_WITH_GMV: 'dpWithGmv',
});

const PRODUCT_FILTER_OPTIONS = [
  { value: ProductFilterMode.ALL, label: 'All' },
  { value: ProductFilterMode.LIVE_DP, label: 'Live DP' },
  { value: ProductFilterMode.LIVE_MFR, label: 'Live MFR' },
  { value: ProductFilterMode.ACTIVE_MFR, label: 'Active MFR' },
  { value: ProductFilterMode.ALL_STATUSES, label: 'All Product Statuses' },
  { value: ProductFilterMode.DP_WITH_GMV, label: 'DP with GMV' },
];

function ProductFilterButtonGroup({ productFilterMode, setProductFilterMode, disabled = false }) {
  return (
    <ButtonGroup className={css(styles.filterButtonGroup)}>
      {PRODUCT_FILTER_OPTIONS.map(option => (
        <Button
          key={option.value}
          variant={productFilterMode === option.value ? 'primary' : 'outline-primary'}
          size="sm"
          onClick={() => setProductFilterMode(option.value)}
          className={css(styles.filterButton)}
          disabled={disabled}
        >
          {option.label}
        </Button>
      ))}
    </ButtonGroup>
  );
}

const styles = StyleSheet.create({
  filterButtonGroup: {
    borderRadius: 6,
  },
  filterButton: {
    fontSize: '0.8rem',
    fontWeight: 500,
    padding: '4px 12px',
  },
});

ProductFilterButtonGroup.propTypes = {
  productFilterMode: PropTypes.string.isRequired,
  setProductFilterMode: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default ProductFilterButtonGroup;
export { ProductFilterMode };
